export function getAuctionStatusClasses(status) {
    const statusClasses = {
        Published: "text-[#B98B47] bg-[#E3C79D]",
        Draft: "text-[#343434] bg-[#B8D5DB]",
        Completed: "text-[#343434] bg-[#DDD1D5]",
        Archived: "text-[#343434] bg-[#D4D4D8]",
        Cancelled: "text-[#984848] bg-[#CA8787]",
        "In Progress" : "text-[#489892] bg-[#A8D9C8]",
        "Accepting bids" : "text-[#489892] bg-[#A8D9C8]",
        Default: "text-[#489892] bg-[#A8D9C8]",
    };

    const hasStatusClass = Object.prototype.hasOwnProperty.call(statusClasses, status);
    return hasStatusClass ? statusClasses[status] : statusClasses.Default;
}